import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "asset-bg",
  "use": "asset-bg-usage",
  "viewBox": "0 0 29.441 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 29.441 28\" id=\"asset-bg\"><title>asset-bg</title><polygon points=\"14.72 0 0 10.695 5.623 28 23.818 28 29.441 10.695 14.72 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol